import { Button, Input, message, Select, Space, Table, Tooltip, InputRef } from 'antd';
import { useContext, useEffect, useRef, useState } from 'react'
import './LayerManage.less';
import Icon, { PlusOutlined, MinusOutlined, CheckOutlined, BulbFilled, BulbOutlined, LockOutlined, UnlockOutlined } from '@ant-design/icons'
import ColorPalette from '../../layout/graphic/operation-bar/color-palette-modal';
import { ReactComponent as OneLayerSvg } from './icons/oneLayer.svg';
import { useParams } from 'react-router-dom';
import { EngineContext } from '@/App';
import { Layer } from '@/declare/interface/project/layer';
import { BaseUtils } from 'tnbase';
import { addLayer, deleteLayer, updateLayer } from '@/declare/api/geometry/layer';
import { PythaEventSetting, SETTING_KEY, UpdateType } from 'pytha2';
import { ContextMenu, MenuItem, MenuList, Modal } from 'bimui';

const { Option } = Select;

// const fakeLayers = [
//     {
//         uuid: "1",
//         name: "Layer 1",
//         hidden: false,
//         lock: false,
//         color: "#ff0000",
//         lineWidth: 0.5,
//     },
//     {
//         uuid: "2",
//         name: "Layer 2",
//         hidden: true,
//         lock: true,
//         color: "#00ff00",
//         lineWidth: 1.0,
//     },
//     {
//         uuid: "3",
//         name: "Layer 3",
//         hidden: false,
//         lock: false,
//         color: "#0000ff",
//         lineWidth: 1.5,
//     },
// ];

/**
 * 图层的管理界面(弹窗)
 * 实现显示、重命名、删除 UCS(目前使用假数据)
 * @returns 
 */
export default function LayerManage() {
    const { projectUuid } = useParams();

    // 引擎相关存储
    const engineContext = useContext(EngineContext);

    /**
     * 控制颜色选择弹窗的显示状态
     */
    const [paletteModalVisible, setPaletteModalVisible] = useState<boolean>(false)

    /**
     * 当前选中的图层对象
     */
    const [selectedLayer, setSelectedLayer] = useState<Layer>();

    /**
     * 控制右键菜单的显示状态
     */
    const [contextMenuVisible, setContextMenuVisible] = useState<boolean>(false)

    /**
     * 右键菜单的左侧位置
     */
    const [contextMenuLeft, setContextMenuLeft] = useState<number>(0)

    /**
     * 右键菜单的顶部位置
     */
    const [contextMenuTop, setContextMenuTop] = useState<number>(0)

    /**
     * - 用于绑定到表单输入框的引用，以便控制其聚焦等操作。
     */
    const refInput = useRef<InputRef>(null)

    /**
     * 图层表格的数据
     */
    // const [tableData, setTableData] = useState(fakeLayers);

    /**
     * 当激活重命名状态时，激活自动聚焦功能
     */
    useEffect(() => {
        if (selectedLayer?.renaming && refInput.current) {
            refInput.current.focus(); // 激活时自动聚焦
        }
    }, [selectedLayer?.renaming]);

    /**
     * 创建图层
     */
    const handleAddLayer = () => {
        let record = selectedLayer;
        if (!record) {
            record = engineContext.layers.find(item => item.uuid === engineContext.currentLayerUuid);
        }
        let uuid = BaseUtils.genUUID();
        let newLayer = { ...record, uuid: uuid, name: record.name + '-' + uuid.slice(0, 6), originLayer: false };
        engineContext.setLayers([
            ...engineContext.layers,
            newLayer,
        ])
        setContextMenuVisible(false);
        addLayer(projectUuid, newLayer).then(res => {

        })
    };
    /**
     * 删除图层
     */
    const handleRemoveLayer = () => {
        let record = selectedLayer;
        let flag = true;
        if (record.uuid === engineContext.currentLayerUuid) {
            flag = false;
        } else if (record.originLayer) {
            flag = false;
        } else if (Object.keys(engineContext.engine?.storage.primitiveStore.primitiveDict).some(key =>
            engineContext.engine?.storage.primitiveStore.primitiveDict[key].layerUuid === record.uuid)) {
            flag = false;
        }
        setContextMenuVisible(false);
        if (!flag) {
            // Modal.error({
            //     title: `图层 ${record.name} 删除失败`,
            //     maskClosable: true,
            //     content: (
            //         <div style={{ marginTop: '20px' }}>
            //             <div>以下图层无法删除：</div>
            //             <ul>
            //                 <li>0图层</li>
            //                 <li>当前图层</li>
            //                 <li>包含对象的图层</li>
            //                 <li>轴网、路网等特殊图层</li>
            //             </ul>
            //         </div>
            //     )
            // })
            message.error("无法删除当前图层、0图层、有对象的图层")
            return;
        }
        let layers = engineContext.layers.filter(item => item.uuid != record.uuid) || [];
        engineContext.setLayers(layers);
        deleteLayer(record.uuid).then(res => {

        })
    };

    /**
     * 重命名图层
     */
    const handleRenameLayer = () => {
        let record = selectedLayer;

        if (record.originLayer) {
            message.error('图层0无法重命名')
            setContextMenuVisible(false)
            return;
        }
        record.renaming = true;
        // engineContext.setLayers(engineContext.layers)
        setContextMenuVisible(false)
    };


    const handleChooseCurrentLayer = () => {
        if (selectedLayer == null) return;
        engineContext.setCurrentLayerUuid(selectedLayer.uuid);
        setContextMenuVisible(false);
    };
    /**
     * 显示调色盘
     */
    const handleColorMangeShow = (record: Layer) => {
        setSelectedLayer(record);
        setPaletteModalVisible(true);
    };

    /**
     * 图层颜色变更
     * @param color 
     */
    const onColorChange = (color: string) => {
        let record = selectedLayer;
        let res = { ...record };
        res.color = color;
        setSelectedLayer(res);
        setPaletteModalVisible(false);
        if (!engineContext.engine) return;
        let event = new PythaEventSetting();
        event.data = {
            key: SETTING_KEY.LAYER_COLOR,
            value: res,
        }
        engineContext.engine.eventMediator?.emitEvent(event);
    }

    /**
     * 切换图层的显示状态
     * @param record 当前操作的图层对象
     */
    const handleHiddenChange = (record: Layer) => {
        // let primitiveDict = engineContext.engine?.storage.primitiveStore.primitiveDict;
        let res = { ...record };
        res.hidden = !record.hidden;
        setSelectedLayer(res);
        // engineContext.setLayers([
        //     ...engineContext.layers
        // ])
        if (!engineContext.engine) return;
        let event = new PythaEventSetting();
        event.data = {
            key: SETTING_KEY.LAYER_SHOW,
            value: res,
        }
        engineContext.engine.eventMediator?.emitEvent(event);
    };
    /**
     * 切换图层的锁定状态
     * @param record 当前操作的图层对象
     */
    const handleLockChange = (record: Layer) => {
        let res = { ...record };
        res.lock = !record.lock;
        setSelectedLayer(res);
        if (!engineContext.engine) return;
        let event = new PythaEventSetting();
        event.data = {
            key: SETTING_KEY.LAYER_LOCK,
            value: res,
        }
        engineContext.engine.eventMediator?.emitEvent(event);
    };
    /**
     * 修改图层线宽
     * @param record 当前操作的图层对象
     * @param value 新的线宽值
     */
    const handleLineWidthChange = (record, value) => {
        message.info(`更改线宽为：${value}`);
    };
    /**
     * 修改图层名称
     * @param record 当前操作的图层对象
     * @param value 新的线宽值
     */
    const changeLayerName = (record: Layer, value: string) => {
        if (value.match(/^\s*$/)) {
            message.warning('此名称的长度必须至少为一个字符。');
            rollbackName(record); // 回滚名称并退出编辑状态
            return;
        }
        if (engineContext.layers.some((item: Layer) => item.uuid != record.uuid && item.name === value.trim())) {
            message.warning(`名称` + value.trim() + `已在使用。`);
            rollbackName(record); // 回滚名称并退出编辑状态
            return;
        }
        // 更新记录
        const updatedRecord = { ...record, name: value.trim(), renaming: false };
        const updatedLayers = engineContext.layers.map((layer) =>
            layer.uuid === record.uuid ? updatedRecord : layer
        );

        // 更新状态
        engineContext.setLayers(updatedLayers);

        updateLayer(projectUuid, updatedRecord).then(res => {

        })
    }
    /**
     * 重命名失败恢复重命名前的状态
     * @param record 
     */
    const rollbackName = (record: Layer) => {
        // 将 renaming 状态设置为 false 并还原名称
        const updatedLayers = engineContext.layers.map((layer) =>
            layer.uuid === record.uuid ? { ...layer, renaming: false } : layer
        );

        engineContext.setLayers(updatedLayers);
    };


    return (
        <div className="layer-manage-container">
            {/* 图层弹窗的操作栏分别为 */}
            <div className="manage-header">
                <Space>
                    <Tooltip title="新建">
                        <Button size="small" type="dashed" icon={<PlusOutlined />} onClick={handleAddLayer}></Button>
                    </Tooltip>
                    <Tooltip title="删除">
                        <Button size="small" type="dashed" icon={<MinusOutlined />} onClick={handleRemoveLayer}></Button>
                    </Tooltip>
                    <Tooltip title="置为当前">
                        <Button size="small" type="dashed" icon={<CheckOutlined style={{ color: '#57a500' }} />} onClick={handleChooseCurrentLayer}></Button>
                    </Tooltip>
                </Space>
            </div>
            <div className="manage-body">
                <Table
                    rowKey="uuid"
                    bordered
                    dataSource={engineContext.layers}
                    pagination={false}
                    sticky
                    onRow={(record) => {
                        return {
                            onClick: event => { setSelectedLayer(record) },
                            onContextMenu: event => {
                                setSelectedLayer(record)
                                setContextMenuVisible(true)
                                setContextMenuLeft(event.clientX)
                                setContextMenuTop(event.clientY)
                                event.preventDefault();
                            },
                        }
                    }}
                    rowClassName={(record) => (record.uuid === selectedLayer?.uuid ? "row-selected" : "")}
                >
                    <Table.Column title="状态" key="status" width="55px" render={(record) => (
                        <div>
                            {record.uuid === engineContext.currentLayerUuid ? (
                                <CheckOutlined style={{ color: '#57a500' }} />
                            ) : (
                                <Icon component={OneLayerSvg} style={{ color: '#0168B3' }} />
                            )}
                        </div>
                    )} />
                    <Table.Column title="名称" key="name" ellipsis render={(record: Layer) => {

                        return !!record.renaming ? (
                            <Input
                                ref={refInput} // 将引用绑定到输入框
                                size="small"
                                bordered={false}
                                style={{ backgroundColor: '#fff' }}
                                defaultValue={record.name}
                                onBlur={(e) => { changeLayerName(record, e.target.value) }}
                                //@ts-ignore
                                onPressEnter={e => changeLayerName(record, e.target.value)} />
                        ) : (
                            <div style={{ cursor: 'pointer', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', }}>{record.name}</div>
                        )
                    }} sorter={(a, b) => a.name > b.name ? 1 : -1} />
                    <Table.Column title="显示" key="hidden" width="70px" render={(record) => (
                        <div className="visible-select" onClick={() => handleHiddenChange(record)}>
                            {!record.hidden ? <BulbFilled /> : <BulbOutlined style={{ color: '#44C1F8' }} />}
                        </div>
                    )} />
                    <Table.Column title="冻结" key="lock" width="70px" render={(record) => (
                        <div className="lock-select" onClick={() => handleLockChange(record)}>
                            {record.lock ? <LockOutlined style={{ color: '#DB1919' }} /> : <UnlockOutlined style={{ color: '#0168B3' }} />}
                        </div>
                    )} />
                    <Table.Column title="颜色" key="color" width="120px" render={(record) => (
                        <div className="color-select" onClick={() => handleColorMangeShow(record)}>
                            <div className="color-box" style={{ backgroundColor: record.color }}></div>
                            <div>
                                {record.color}
                            </div>
                        </div>
                    )} />
                    {/* <Table.Column title="线宽" key="lineWidth" width="150px" render={(record) => (
                        <Select
                            dropdownStyle={{ backgroundColor: '#757575' }}
                            style={{ width: '100%' }}
                            size="small"
                            value={record.lineWidth}
                            onChange={(e) => handleLineWidthChange(record, e)}>
                            {[0.5, 1.0, 1.5].map((width) => (
                                <Option key={width} value={width}>
                                    {width} 毫米
                                </Option>
                            ))}
                        </Select>
                    )} /> */}
                </Table>
            </div>
            {/*  */}
            <Modal
                title="选择颜色"
                open={paletteModalVisible}
                width={600}
                wrapClassName="color-select-modal"
                onCancel={() => { setPaletteModalVisible(false) }}
                showFooter={false}
            >
                <div className="color-select-modal-body">
                    <ColorPalette
                        onComplete={(color: string) => onColorChange(color)}
                        onCancel={() => { setPaletteModalVisible(false) }}></ColorPalette>
                </div>
            </Modal>



            <ContextMenu
                visible={contextMenuVisible}
                left={contextMenuLeft}
                top={contextMenuTop}
                wrapperClassname='layer-context-menu-wrapper'
                onCancel={() => { setContextMenuVisible(false) }}
            >
                <MenuList>
                    <MenuItem onClick={handleChooseCurrentLayer}>
                        置为当前
                    </MenuItem>
                    <MenuItem onClick={handleAddLayer}>
                        新建图层
                    </MenuItem>
                    <MenuItem onClick={handleRemoveLayer} special>
                        删除图层
                    </MenuItem>
                    <MenuItem onClick={handleRenameLayer}>
                        重命名
                    </MenuItem>
                </MenuList>
            </ContextMenu>
        </div>
    )
}

